import { RangeSlider } from '@alltrails/denali/components/Slider';
import useRangeSliderDraft from '../../hooks/useRangeSliderDraft';
import type { RangeSliderFilterConfigV2 } from './types';

const RangeSliderFilterControl = ({ filterConfig }: { filterConfig: RangeSliderFilterConfigV2 }) => {
  const { draft, onChange, onChangeEnd } = useRangeSliderDraft(filterConfig.rangeSlider);

  return (
    <RangeSlider
      {...filterConfig.rangeSlider}
      value={draft}
      onChange={onChange}
      onChangeEnd={onChangeEnd}
      headerValueTextVariant="text100"
      labelTextVariant="heading200"
    />
  );
};

export default RangeSliderFilterControl;
